import React, { useState } from "react";
import PublishEmbedModal from "rc-app/components/PublishEmbedModal";
import { mintLocalKey, type EmbedSite, type Placements } from "rc-app/utils/publishEmbedFlow";

/* ── Publish modal preview harness ───────────────────────────────────────
   Route: /publish-preview  (authenticated — just navigate while logged in).

   The embed endpoints 404 until Nivedita lands them, so this page seeds the
   design handoff's own sample data and runs the modal fully offline: every
   toggle, tick, gate switch, host expansion, code card and domain validation
   works, nothing calls out. Same purpose as /leadgate-preview.

   Seed is the README's table verbatim, so the screen can be compared against
   `Publish Modal v4.html` side by side:
       S1 ruchiraprojects.com (subs on,  gate Open)   → MM1, DT1
       S2 villafeliz.in       (subs off, gate Open)   → DT1, DT3
       S3 ruchirahomes.com    (subs off, gate Closed) → DT2
*/

const META_MODELS = [
  { id: "mm1", name: "3BHK — 1725 sqft", sub: "Tower A" },
];
const DIGITAL_TWINS = [
  { id: "dt1", name: "Tower A exterior", sub: "Drone capture" },
  { id: "dt2", name: "Clubhouse", sub: "Amenity block" },
  { id: "dt3", name: "Podium landscape", sub: "Level 5 deck" },
];

const SITES: EmbedSite[] = [
  { id: "s1", code: "S1", domain: "ruchiraprojects.com", label: "Main website", lead: true, subs: true },
  { id: "s2", code: "S2", domain: "villafeliz.in", label: "Campaign microsite", lead: true, subs: false },
  { id: "s3", code: "S3", domain: "ruchirahomes.com", label: "Blog & content site", lead: false, subs: false },
];

const live = () => ({ key: mintLocalKey(), published: true, local: true });

const PLACEMENTS: Placements = {
  s1: { mm1: live(), dt1: live() },
  s2: { dt1: live(), dt3: live() },
  s3: { dt2: live() },
};

const PublishPreview: React.FC = () => {
  const [open, setOpen] = useState(true);
  return (
    <div style={{ minHeight: "100vh", background: "#132E28", padding: 24 }}>
      {!open && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          style={{
            font: "600 13px/1 Inter, system-ui, sans-serif",
            color: "#04130B", background: "#13A06A",
            border: 0, borderRadius: 9, padding: "11px 16px", cursor: "pointer",
          }}
        >
          Open the publish modal
        </button>
      )}
      {open && (
        <PublishEmbedModal
          projectId="preview"
          projectName="Ruchira Villa Feliz"
          metaModels={META_MODELS}
          digitalTwins={DIGITAL_TWINS}
          seed={{ sites: SITES, placements: PLACEMENTS }}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
};

export default PublishPreview;
